import React from "react";

const Collaborations = () => {
  // Sample dataset with image URLs
  const mediaDataset = [
    "collaboration/collab1.JPG",
    "collaboration/collab2.MP4",
    "collaboration/collab3.jpg"
  ];

  return (
    <div className="collaborations-container">
      {/* Heading Section */}
      <h2 className="collaborations-heading">Our Collaborations</h2>

      <div className="media-grid">
        {mediaDataset.map((media, index) => {
          const isVideo = media.endsWith(".mp4") || media.endsWith(".MP4");
          return (
            <div className="media-item" key={index}>
              {isVideo ? (
                <video
                  className="media"
                  src={media}
                  controls
                  alt={`collaboration video ${index}`}
                />
              ) : (
                <img
                  className="media"
                  src={media}
                  alt={`collaboration image ${index}`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Collaborations;
